import type {AccountInformation} from '@/auth/model'
import getAccountInformation from '@/auth/utils/getAccountInformation'
import {useAtomEffect} from '@/utils/jotai/useAtomEffect'

export const accountInformationAtom = atom(getAccountInformation())

export default function useAccountInformation() {
  return useAtom(accountInformationAtom)
}

export function useSetAccountInformation() {
  return useSetAtom(accountInformationAtom)
}

export function useAccountInformationValue() {
  return useAtomValue(accountInformationAtom)
}

export function useGetAccountInformation() {
  const store = useStore()
  return useCallback(() => store.get(accountInformationAtom), [store])
}

export function createAccountInformationEffect(
  onAccountInformationChange: (
    accountInformation: AccountInformation | undefined,
    // eslint-disable-next-line @typescript-eslint/no-invalid-void-type -- valid void
  ) => (() => void) | undefined | void,
) {
  return atomEffect(get => {
    const accountInformation = get(accountInformationAtom)
    return onAccountInformationChange(accountInformation)
  })
}

export function useAccountInformationEffect(
  accountInformationDispatch: Dispatch<SetStateAction<AccountInformation | undefined>>,
) {
  useAtomEffect(accountInformationAtom, accountInformationDispatch)
}
